import React from 'react';
import PropTypes from 'prop-types';
import { FaRegImage } from 'react-icons/fa';
import * as Styled from './styles';

const ImageUnavailable = ({ name, iconSize }) => (
  <Styled.Wrapper>
    <Styled.IconBox>
      <FaRegImage size={iconSize} aria-hidden="true" />
    </Styled.IconBox>
    <span>Image unavailable</span>
    {name && (
      <>
        <Styled.Separator>·</Styled.Separator>
        <Styled.FileName>{name}</Styled.FileName>
      </>
    )}
  </Styled.Wrapper>
);

ImageUnavailable.propTypes = {
  name: PropTypes.string,
  iconSize: PropTypes.number,
};

ImageUnavailable.defaultProps = {
  name: '',
  iconSize: 16,
};

export default ImageUnavailable;
